import styled from 'styled-components';
import { PageContainer } from '../components/common/PageComponent.style';
import PageTop from '../components/pageTop/PageTop';
import Footer from '../components/footer/Footer';
import LandingFooter from './components/LandingFooter';
import { useModal } from '../../context/ModalContext';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../../context/UserContext';
import { useEffect, useRef, useState } from 'react';
import { isLogin } from '../../utils/auth';
import UserService from '../../service/User';
import CouponService from '../../service/coupon/Coupon';
import ConfirmAlert from '../components/alert/ConfirmAlert';
import ScratchCoupon from './components/lucky/ScratchCoupon';
import CouponListModal from './components/lucky/CouponListModal';
import WinningListModal from './components/lucky/WinningListModal';
import KakaoService from '../../service/kakao/Kakao';
import EventAlert from './components/lucky/EventAlert';

const BASE_IMAGE_URL = '/assets/images/promotion/lucky';

const localList = [
  {
    name: '서울',
    img: `${BASE_IMAGE_URL}/seoul`,
    value: 'C',
  },
  {
    name: '수도권',
    img: `${BASE_IMAGE_URL}/capital`,
    value: 'D',
  },
  {
    name: '충청도',
    img: `${BASE_IMAGE_URL}/chungcheong`,
    value: 'G',
  },
  {
    name: '강원도',
    img: `${BASE_IMAGE_URL}/gangwon`,
    value: 'H',
  },
  {
    name: '경상도',
    img: `${BASE_IMAGE_URL}/gyeongsang`,
    value: 'I',
  },
  {
    name: '호남권',
    img: `${BASE_IMAGE_URL}/honam`,
    value: 'J',
  },
];

const footerData = {
  data: [
    {
      title: '이벤트 유의사항',
      content: [
        '웰컴 럭키 이벤트 기간 : 상시',
        '땅집고옥션 회원이라면 누구나 참여 가능합니다.',
        '내부 사정으로 상품 혜택이 변경될 수 있으며, 이벤트는 고지없이 조기 마감 및 연장될 수 있습니다.',
        '부적절한 방법으로 이벤트에 참여할 경우 이벤트 참여가 영구적으로 제한될 수 있습니다.',
      ],
    },
  ],
  more: [
    {
      title: 'EVENT 01 랜덤 쿠폰증정 이벤트',
      content: [
        '본 이벤트는 ID당  매일 기본 1회 참여가 가능합니다.',
        '쿠폰은 [마이페이지 - 쿠폰함] 에서 확인 가능하며, 유효기간은 발급일로부터 7일입니다.',
        '본 이벤트에서 발급된 쿠폰은 중복 사용이 불가합니다.',
        '쿠폰 적용 상품 환불 시, 할인 금액을 제외한 실 결제 금액으로 환불됩니다.',
      ],
    },
    {
      title: 'EVENT02 카톡 공유하기 이벤트',
      content: [
        '카톡 공유하기 이벤트는 신규가입 후 2주 이내 회원이라면 로그인 후 누구나 참여 가능하며, ID당 1회만 참여 가능합니다.',
        '발급받은 쿠폰은 [마이페이지 - 쿠폰함]에서 확인 가능하며, 유효기간은 발급일로부터 14일입니다.',
        '카카오톡 공유하기 완료 시 무료 이용권 자동 지급되오니 원하는 지역 선택하신 후 참여 가능합니다.',
        '나에게 공유하기는 참여한 것으로 간주하지 않습니다.',
      ],
    },
  ],
};

function Lucky() {
  const navigate = useNavigate();
  const { modalDispatch } = useModal();
  const { user } = useUser();

  const [selectRegion, setSelectRegion] = useState('');
  const [showCouponListModal, setShowCouponListModal] = useState(false);
  const [showWinningListModal, setShowWinningListModal] = useState(false);

  const [showShareAlert, setShowShareAlert] = useState<string | null>(null);
  const [userKey, setUserKey] = useState<string | null>(null);
  const [kakaoReady, setKakaoReady] = useState(false);

  const shareKakao = async () => {
    try {
      const res = await KakaoService.chat(selectRegion);
      return true;
    } catch (error: any) {
      const message = error?.response?.data?.message;

      if (message === '이벤트 신청 대상이 아닙니다.') {
        setShowShareAlert('not-target');
      }

      if (message === '이미 신청한 사용자입니다.') {
        setShowShareAlert('already');
      }
    }
  };

  const getUserInfo = async () => {
    try {
      const res = await UserService.userInfo();
      setUserKey(res.data?.user_key ?? null);
      if (window.Kakao && !window.Kakao.isInitialized()) {
        window.Kakao.init(process.env.REACT_APP_KAKAO_SHARE_API_KEY || ''); // 앱의 JavaScript 키
      }

      if (window.Kakao) setKakaoReady(true);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    // 스크립트가 로드되었는지 확인
    if (!isLogin()) return;
    getUserInfo();
  }, []);

  const handleShareClick = async () => {
    if (!isLogin()) {
      modalDispatch({ type: 'USER_ALERT', payload: 'guest' });
      return;
    }
    if (!selectRegion) {
      setShowShareAlert('region');
      return;
    }

    const ok = await shareKakao();
    if (!ok) {
      return;
    }

    if (!window.Kakao || !kakaoReady) return;
    window.Kakao.Share.sendDefault({
      objectType: 'feed',
      serverCallbackArgs: {
        send_uuid: userKey ?? '',
        type: 'Thanksgiving Day',
      },
      content: {
        title: '꽝 없는 100% 당첨 이벤트',
        description: '최대 50% 할인 쿠폰부터 1개월 무료 이용권까지!',
        imageUrl: 'https://zipgoai.com/assets/images/lucky-share-img.png',
        link: {
          mobileWebUrl:
            'https://m.zipgoai.com/promotion/땅집고옥션-럭키-이벤트',
          webUrl: 'https://zipgoai.com/promotion/땅집고옥션-럭키-이벤트',
        },
      },
      buttons: [
        {
          title: '쿠폰 받기',
          link: {
            mobileWebUrl:
              'https://m.zipgoai.com/promotion/땅집고옥션-럭키-이벤트',
            webUrl: 'https://zipgoai.com/promotion/땅집고옥션-럭키-이벤트',
          },
        },
      ],
    });
  };

  return (
    <Component>
      <PageContainer>
        <PageTop logo />

        <MainImg />

        <Section>
          <Content>
            <SectionTitleContainer>
              <EventNumberBadge $bg="#39AEFB">EVENT 01</EventNumberBadge>
              <SectionTitle $color="#39AEFB">
                <SectionTitleDesc>꽝 없는 100% 당첨</SectionTitleDesc>
                매일 매일 랜덤 쿠폰 이벤트
              </SectionTitle>
            </SectionTitleContainer>
            <ScratchCoupon />
            <ListButton onClick={() => setShowWinningListModal(true)}>
              당첨내역 확인하기 {'>'}
            </ListButton>
          </Content>
          <Content>
            <CouponDetailContainer>
              <img src={`${BASE_IMAGE_URL}/coupon-list.png`} alt="" />
              <CouponListButton onClick={() => setShowCouponListModal(true)} />
            </CouponDetailContainer>
            <SectionDesc>
              <span>・쿠폰 유효기간은 발급일로부터 7일입니다.</span>
              <span>
                ・자세한 쿠폰 사용방법 및 범위는 하단 유의사항 확인해 주세요.
              </span>
              <span>
                ・쿠폰은 [마이페이지 - 쿠폰함]에서 확인하실 수 있습니다.
              </span>
            </SectionDesc>
          </Content>
        </Section>

        <KakaoSection>
          <Content>
            <SectionTitleContainer>
              <EventNumberBadge $bg="#138C2A">EVENT 02</EventNumberBadge>
              <SectionTitle $color="#138C2A">
                원하는 지역 무료 이용권 드려요!
                <SectionTitleDesc>
                  원하는 지역을 고른 후 카톡 공유하면
                  <br />
                  24시간 무료 이용권을 드립니다.
                </SectionTitleDesc>
              </SectionTitle>
            </SectionTitleContainer>
            <LocalSelectSection>
              {localList.map((local) => (
                <LocalSelectOption
                  key={local.value}
                  onClick={() => setSelectRegion(local.value)}
                >
                  <SelectOptionImg
                    src={`${local.img}${selectRegion === local.value ? '-active' : ''}.png`}
                    alt={local.name}
                    draggable={false}
                  />
                </LocalSelectOption>
              ))}
            </LocalSelectSection>
            <ButtonContainer>
              <ShareButtonWrapper>
                <img src={`${BASE_IMAGE_URL}/share-button.png`} alt="" />
                <ShareButton onClick={handleShareClick} />
              </ShareButtonWrapper>
              <CouponBoxButton
                onClick={() => {
                  if (!isLogin()) {
                    modalDispatch({ type: 'USER_ALERT', payload: 'guest' });
                    return;
                  }

                  sessionStorage.setItem('mypageTab', 'coupon');
                  navigate('/mypage');
                }}
              >
                쿠폰함 확인 {'>'}
              </CouponBoxButton>
            </ButtonContainer>
            <SectionDesc>
              <ShareSectionDesc>
                <span>※</span>
                <span>이벤트 대상자 : 신규 가입 후 2주 이내 회원 </span>
              </ShareSectionDesc>
              <ShareSectionDesc>
                <span>※</span>
                <span>
                  공유하기 이벤트 참여 시, ‘나에게 공유하기'는 쿠폰이 지급이
                  되지 않습니다.
                </span>
              </ShareSectionDesc>
              <ShareSectionDesc>
                <span>※</span>
                <span>
                  원하는 지역 선택 후 공유하기를 완료하면 이용권은 자동
                  지급됩니다. 지급된 쿠폰은 마이페이지 {'>'} 쿠폰함에서
                  확인가능합니다.
                </span>
              </ShareSectionDesc>
            </SectionDesc>
          </Content>
        </KakaoSection>

        <LandingFooter data={footerData.data} moreSection={footerData.more} />
        <Footer />

        {showCouponListModal && (
          <CouponListModal onClose={() => setShowCouponListModal(false)} />
        )}
        {showWinningListModal && (
          <WinningListModal onClose={() => setShowWinningListModal(false)} />
        )}

        {showShareAlert && (
          <EventAlert
            text={
              showShareAlert === 'region'
                ? '원하는 지역을 선택하세요.'
                : showShareAlert === 'not-target'
                  ? '이벤트 대상이 아닙니다'
                  : showShareAlert === 'already'
                    ? '이미 이벤트에 참여하셨습니다.'
                    : '쿠폰이 발급되었습니다.'
            }
            desc={showShareAlert === 'confirm' ? '쿠폰함을 확인해 주세요.' : ''}
            onClose={() => setShowShareAlert(null)}
          />
        )}
      </PageContainer>
    </Component>
  );
}

export default Lucky;

const Component = styled.div`
  word-break: keep-all;
  -webkit-text-size-adjust: 100%;
  text-size-adjust: 100%;
`;

const MainImg = styled.div`
  background-image: url('/assets/images/promotion/lucky/topbg.png');
  background-size: cover;
  background-position: center;
  width: 100%;
  aspect-ratio: 45/59;
`;

const Section = styled.div`
  display: flex;
  width: 100%;
  padding: 40px 16px;
  flex-direction: column;
  align-items: center;
  gap: 30px;
  background: #f7f8fa;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  align-self: stretch;
`;

const SectionTitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
`;

const EventNumberBadge = styled.div<{ $bg?: string }>`
  display: flex;
  padding: 6px 24px;
  justify-content: center;
  align-items: center;
  border-radius: 999px;
  background: ${({ $bg }) => $bg ?? '#FFF'};
  color: #fff;
  text-align: center;
  font-family: Pretendard;
  font-size: 16px;
  font-weight: 500;
  line-height: 150%;
  letter-spacing: -0.32px;
`;

const SectionTitle = styled.div<{ $color?: string }>`
  display: flex;
  flex-direction: column;
  align-items: center;

  color: ${({ $color }) => $color ?? '#FFF'};
  text-align: center;
  font-family: Pretendard;
  font-size: 24px;
  font-weight: 800;
  line-height: 140%;
  letter-spacing: -0.48px;
`;

const SectionTitleDesc = styled.div`
  color: #222;
  text-align: center;
  font-family: Pretendard;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 140%; /* 28px */
  letter-spacing: -0.4px;
`;

const Button = styled.button`
  border: none;
  outline: none;
  cursor: pointer;

  display: flex;
  padding: 18px 48px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 16px;

  text-align: center;
  font-family: Pretendard;
  font-size: 18px;
  font-weight: 700;
  line-height: 140%;
  letter-spacing: -0.72px;
`;

const ListButton = styled(Button)`
  background: #222;
  color: #fff;
`;

const CouponDetailContainer = styled.div`
  width: 100%;
  position: relative;

  & > img {
    width: 100%;
    aspect-ratio: 328 / 377;
  }
`;

const CouponListButton = styled.button`
  position: absolute;
  bottom: calc(100% / 2 + 2.5px);
  left: calc(24 * 100% / 328);

  width: calc(165 * 100% / 328);
  height: calc(45 * 100% / 328);
  background: #fff;
  /* background: transparent; */
  border: none;
  cursor: pointer;
  z-index: 1;
  opacity: 0;
`;

const SectionDesc = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  align-self: stretch;

  color: #888;
  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 145%; /* 17.4px */
  letter-spacing: -0.24px;
`;

const KakaoSection = styled(Section)`
  background:
    linear-gradient(0deg, #fff 0%, #fff 100%),
    linear-gradient(180deg, #f4fffb 0%, #eafff6 100%);
`;

const LocalSelectSection = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  align-self: stretch;
`;

const SelectOptionImg = styled.img`
  position: absolute;
  inset: 0;

  width: 100%;
  height: 100%;
  -webkit-user-drag: none;
`;

const LocalSelectOption = styled.div`
  position: relative;
  aspect-ratio: 1/1;
  flex: 1 0 0;
  border-radius: 12px;

  cursor: pointer;
`;

const ShareButtonWrapper = styled.div`
  width: 284px;
  position: relative;

  & > img {
    width: 100%;
    height: 96px;
  }
`;

const ShareButton = styled.button`
  position: absolute;
  bottom: 0;
  left: 0;

  width: 284px;
  height: 72px;
  background: transparent;
  border: none;
  cursor: pointer;
  z-index: 1;
  opacity: 0;
`;

const ShareSectionDesc = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 2px;
  align-self: stretch;
  color: #888;
  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 145%; /* 17.4px */
  letter-spacing: -0.24px;
`;

const CouponBoxButton = styled(Button)`
  width: 100%;
  background: #222;
  color: #fff;
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`;
